import React from "react";
import { Button } from "@my-scoot/component-library-legacy";
import classnames from "classnames";

import { SHOW_CONTENT_LENGTH } from "ui/pages/TemplatePreview/constants";
import styles from "./../style.module.css";

const PointersCard = (props) => {
  const { imgSrc, title, description, footerBtn } = props;

  return (
    <div className={styles.pointersCardContainer}>
      <div className={styles.pointerCardHead}>
        {imgSrc ? (
          <img
            className={styles.pointerCardImg}
            src={imgSrc}
            alt="Pointer Cover Image"
          />
        ) : null}
        <div className={classnames(styles.pointerCardTitle, imgSrc && "pt-2")}>
          {title}
        </div>
      </div>
      <div className={styles.pointerCardBody}>
        <div className={styles.pointerCardDesc}>
          {description?.length > SHOW_CONTENT_LENGTH
            ? `${description?.substring(0, SHOW_CONTENT_LENGTH)}...`
            : description}
        </div>
        {footerBtn && (
          <Button
            className={styles.pointerCardBtn}
            color="link"
            variant="text"
            size="thin"
            disableTouchRipple={true}
          >
            {footerBtn}
          </Button>
        )}
      </div>
    </div>
  );
};

export default PointersCard;
